import { Component, Injector } from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material";
import { FormControl, FormGroup, Validators, FormGroupDirective, NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { DatePipe } from "@angular/common";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { ErrorStateMatcher } from '@angular/material/core';
import * as moment from 'moment';
import Swal from "sweetalert2";
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle } from '../../../models/messages';
import { ProformaDetalle } from '../../../models/ProformaDetalle';
import { DocumentoNegociableService } from '../../../services/documento-negociable/documento-negociable.service';
import { LocalService } from './../../../services/storage/localService';
import { ProformaService } from './../../../services/operaciones/proforma/proforma.service';
import { LoginService } from 'app/services/login/login.service';
import { GuiasService } from 'app/services/guias/guias.service';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { environment } from 'environments/environment';
import { RiesgoService } from './../../../services/riesgo/riesgo.service';
import { InversionistaDetalle } from '../../../models/InversionistaDetalle';
import { of } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY ",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;

@Component({
  selector: 'app-nuevo-proforma',
  templateUrl: './nuevo-proforma.component.html',
  styleUrls: ['./nuevo-proforma.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})

export class NuevoProformaComponent {
  Id_Confirming = environment.ID_CONFIRMING;
  Id_Factoring = environment.ID_FACTORING;
  Id_Descuento = environment.ID_DESCUENTO;
  Id_Moneda_Dolares = environment.ID_GUIA_DOLARES;
  ID_ROL_PRONTOPAGO = environment.ID_ROL_PP;
  servifinMode = environment.SERVIFIN_MODE;
  labelPorcNeg = environment.LABEL_PORC_NEG;
  labelTasaInversion = environment.LABEL_TASA_INVERSION;
  labelTasaComision = environment.LABEL_TASA_COMISION;
  labelGravamen = environment.LABEL_GRAVAMEN;
  flagEspecial: boolean = false;
  MILISENGUNDOS_POR_DIA = 1000 * 60 * 60 * 24;

  varDiasMin: any = 0;
  varDiasMax: any = 0;
  varAdelantoMin: any = 0;
  varAdelantoMax: any = 0;
  varAdelantoDef: any = 0;
  varTasaMin: any = 0;
  varTasaMax: any = 0;
  IGV_Porcentaje: any = 0;
  igvPorcentajeGlobal: any = 0;
  flgCalcular: boolean = false;
  arrayDocumentos: any = [];
  actualizarDocumentos: any = [];
  user: any;
  minFromDate = new Date('2022/01/01');
  nroFacturas: number = 0;
  TEM: number = 0;
  TEMAutomatico: number = 0;
  flgTEMAutomatico: boolean = false;
  flgNotificar: boolean = false;
  loading: boolean = false;
  formTEM: FormGroup;
  formProforma: FormGroup;
  proformaDetalle: ProformaDetalle[] = [];
  rProveedor: any = [];
  Nombre_de_Contacto: string = "";
  correo: string = "";
  idProforma: number = 0;
  idProveedor: number = 0;
  ProformaSave: any = [];
  optionValue;
  tipoServicioElement = 0;
  sumainteres: number = 0;
  ocultarAdq: boolean = false;
  comisionPeso: number = 0; 
  prospectoFiltroAdq: any;
  prospectoFiltroProv: any;
  boton: boolean = true;
  CODIGO_MONEDA: any = 'COP';
  fondos: any = [];
  
  inversionistaDetalle : InversionistaDetalle[] = [];
  varAbrirInversionista : boolean = false;

  ProformaTotales: any = {
    VNPP: 0,
    Adelanto: 0,
    Interes: 0,
    InteresAdq: 0,
    InteresProv: 0,
    Comision: 0,
    IGV_TOTAL: 0,
    Desembolso: 0,
    Remanente: 0,
    IGVProv: 0,
    Timbres: 0,
    Feci: 0,
    Gastos_legales: 0,
    Gastos_cesion: 0,
    DesembolsoProvConfirming: 0,
    Plazo:0,
    Valor_Venta_Retroventa :  0,
    Valor_Venta_Retroventa_Saldo :  0, 
    Otros_Descuentos :  0
  };

  ProformaConDetalle: any = {
    proforma_detalle: [],
    idEmpresa: 1
  };

  datosDN: any;
  check0: boolean = false;
  Date = new Date();
  PlazoMaximo = 0;

  proformaGeneral: any = {
    "Num_Doc_Identificacion_Prov": "",
    "Num_Doc_Identificacion_ADQ": "",
    "Ranking_Adquirente": "",
    "Tasa_Tipo_de_Calculo": "",
    "Tasa_Anual": "",
    "Tasa_Mensual_Sistema": "",
    "Tasa_Mensual": "",
    "Tasa_Diaria": "",
    "Moneda": "",
    "Adelanto_porcentaje": "",
    "Cantidad_de_Documentos_Negociables": "",
    "Fecha_Desembolso": "",
    "Fecha_Vigencia": "",
    "Adjunto_PDF": "",
    "Observaciones": "",
    "ProformaDetalle": []
  }

  empresasService: EmpresasService;
  proformaService: ProformaService;
  documentoNegociableService: DocumentoNegociableService;
  loginService: LoginService;
  localService: LocalService;
  guiasService: GuiasService;
  riesgoService:RiesgoService;

  constructor(private injector: Injector,
    private datepipe: DatePipe,
    private msgAgregarSimulador: MessagesSimuladorAgregarDetalle,
    private msgTitulos: MessagesTitles,
    private router: Router
  ) {
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);
    this.proformaService = this.injector.get<ProformaService>(ProformaService);
    this.documentoNegociableService = this.injector.get<DocumentoNegociableService>(DocumentoNegociableService);
    this.loginService = this.injector.get<LoginService>(LoginService);
    this.localService = this.injector.get<LocalService>(LocalService);
    this.guiasService = this.injector.get<GuiasService>(GuiasService);
    this.riesgoService = this.injector.get<RiesgoService>(RiesgoService);

    this.varDiasMin = this.localService.getJsonValue('ParametroRechazoMin');
    this.varDiasMax = this.localService.getJsonValue('ParametroRechazoMax');
    this.varAdelantoMin = (this.localService.getJsonValue('ParametroAdelantoMinimo') * 100);
    this.varAdelantoMax = (this.localService.getJsonValue('ParametroAdelantoMaximo') * 100);
    this.varAdelantoDef = (this.localService.getJsonValue('ParametroAdelandoDefault') * 100);
    this.varTasaMin = this.localService.getJsonValue('ParametroTasaMinimoComercial');
    this.varTasaMax = this.localService.getJsonValue('ParametroTasaMaximo');
    this.igvPorcentajeGlobal = this.localService.getJsonValue('ParametroIGVPorcentaje');

    try {
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.datosDN = this.proformaService.datosProforma;
      this.validarProvAdq(this.datosDN.Num_Doc_Identificacion_Prov, this.datosDN.Num_Doc_Identificacion_Adq);
      this.ObtenerDocumentosNegociables();
      this.ObtenerRanking();
    } catch (error) {
      this.loginService.clickGuard = true;
      this.router.navigate(['/operaciones/proformas/listado']);
    }

    let now = moment();

    this.formTEM = new FormGroup({
      'Plazo': new FormControl(''),
      'VNPP': new FormControl(''),
      'NombreComercialProv': new FormControl(this.datosDN.NombreComercialProv),
      'NombreComercialAdq': new FormControl(this.datosDN.NombreComercialAdq),
      'ProveedorScore': new FormControl(this.datosDN.ScoringProv),
      'AdquirenteScore': new FormControl(this.datosDN.ScoringAdq),
      'Num_Doc_Identificacion_Prov': new FormControl(this.datosDN.Num_Doc_Identificacion_Prov),
      'Num_Doc_Identificacion_ADQ': new FormControl(this.datosDN.Num_Doc_Identificacion_Adq),
      'ValorTipoCambio': new FormControl(3.33),
      'TipoCambio': new FormControl(this.datosDN.TipoCambio),
      'Moneda_Dsc': new FormControl(this.datosDN.Moneda_Dsc),
      'Adelanto_Porcentaje': new FormControl(
        this.servifinMode ? environment.SERVIFIN_PORC_NEG_DEFAULT : 90,
        [Validators.required, Validators.pattern('^[0-9.]+$')]
      ),
      'Tipo_Comprobante': new FormControl((this.datosDN.Tipo_Comprobante == 'F') ? 'Factura' : 'Recibo Honorario'),
      'Fecha_Desembolso': new FormControl(now),
      'Ranking': new FormControl(''),
      'Interes_Adquirente': new FormControl(0, [Validators.pattern('^[0-9.]+$')]),
      'Tipo_Servicio': new FormControl('', [Validators.required]),
      'Gastos_Legales': new FormControl('0', [Validators.required]),
      'Gastos_cesion': new FormControl('0', [Validators.required]),
      'Otros_Descuentos': new FormControl('0', [Validators.required]),
      'Plazo_PA': new FormControl('0', [Validators.required]),
      'Interes_Comision': new FormControl('0', [Validators.required]),
      'Importe_Adquirente': new FormControl(0),
      'Observaciones': new FormControl(''),
      'Tasa_Inversion': new FormControl(environment.SERVIFIN_TASA_INVERSION, [Validators.pattern('^[0-9.]+$')]),
      'TasaCom': new FormControl(environment.SERVIFIN_TASA_COMISION, [Validators.pattern('^[0-9.]+$')]),
      'PorcGrav': new FormControl(environment.SERVIFIN_PORC_GRAV, [Validators.pattern('^[0-9.]+$')]),
      'Comision_Minima': new FormControl(environment.SERVIFIN_COMISION_MINIMA, [Validators.pattern('^[0-9.]+$')]),

    });

    this.formProforma = new FormGroup({
      Fecha: new FormControl(''),
      VNPP: new FormControl(''),
      Tipo_Comprobante: new FormControl(''),
      Fecha_Desembolso: new FormControl(''),
      Moneda: new FormControl(''),
      TEM: new FormControl(''),
      Adelanto_Porcentaje: new FormControl(''),
      Adelanto_Importe: new FormControl(''),
      Interes_Importe: new FormControl(''),
      Comision_Importe: new FormControl(''),
      IGV_Importe: new FormControl(''),
      Desembolso_Importe: new FormControl(''),
      Remanente_Importe: new FormControl(''),
      Num_Doc_IdentificacionP: new FormControl(''),
      Num_Doc_IdentificacionA: new FormControl('')
    });

    //this.tipoServicio(this.Id_Factoring);
    this.CODIGO_MONEDA = (this.Id_Moneda_Dolares == this.datosDN.TipoMoneda) ? 'USD' : 'COP';
    if (this.user.id_roles == this.ID_ROL_PRONTOPAGO) {
      this.tipoServicioElement = 1485;
      this.formTEM.controls['Tipo_Servicio'].setValue(1485);
      this.formTEM.controls['Adelanto_Porcentaje'].setValue(100);
      this.flagEspecial = true;
      this.varAdelantoDef = 1 * 100;

    }
  }
  ngOnInit() { 
    this.listarFondos();
  }
  listarFondos() {
    this.riesgoService.obtenerFondos().subscribe(
      resp => {
        this.fondos = resp
        this.fondos.sort(function(a, b) {
          var textA = a.Razon_Social;
          var textB = b.Razon_Social;
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
        //this.fondos = this.fondos.filter(item => item.Moneda == this.formTEM.controls['TipoCambio'].value() || item.Multiples_Moneda == 'A');
      }, (err: HttpErrorResponse) => {
        this.loading = false;
       // this.msgStatus.getMessage(err.status);
        Swal.fire({
          title: 'error',
          text: "LISTA FONDOS NO OBTENIDO. ",
          type: "error",
          allowOutsideClick: false
        });
      });
  }
  calcularProforma(modo: boolean, TEM: number) {
    if (this.formTEM.controls['Tipo_Servicio'].value == '') {
      Swal.fire({
        title: "¡Advertencia!",
        text: "Seleccione el tipo de servicio.",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }

    this.loading = true;
    let plazo: any = [];
    this.PlazoMaximo = 0;
    let sumaVNPP: number = 0.00;
    this.TEM = 0;
    this.nroFacturas = 0;

    for (let item of this.proformaDetalle) {
      if (item.checked) {
        this.nroFacturas++;
        plazo.push(item.Plazo);
        sumaVNPP += Number(item.VNPP);
      }
    }
    this.resetear();
    if (plazo.length > 0) this.PlazoMaximo = Math.max(...plazo);
    //this.PlazoMaximo = this.formTEM.controls['Plazo_PA'].value
    this.formTEM.controls['TipoCambio'].setValue(this.datosDN.TipoMoneda);
    this.formTEM.controls['Num_Doc_Identificacion_Prov'].setValue(this.datosDN.Num_Doc_Identificacion_Prov);
    this.formTEM.controls['Num_Doc_Identificacion_ADQ'].setValue(this.datosDN.Num_Doc_Identificacion_Adq);
    this.formTEM.controls['Plazo'].setValue(this.PlazoMaximo);
    this.formTEM.controls['VNPP'].setValue(sumaVNPP);

    this.ProformaTotales.Plazo = this.PlazoMaximo;

    if (this.formTEM.value.VNPP > 0) {
      const temSource = this.servifinMode
        ? of(Number(this.formTEM.controls['Tasa_Inversion'].value) / 100)
        : this.proformaService.obtenerTEM(this.formTEM.value, 1);

      temSource.subscribe(
        responseTEM => {
          this.TEMAutomatico = Number(responseTEM);
          if (modo) {
            this.TEM = Number(responseTEM);
            this.flgTEMAutomatico = false;
          } else {
            this.TEM = TEM;
            this.flgTEMAutomatico = true;
          }
          let cont_facturas = 0;
          this.proformaDetalle.forEach((item, index) => {
            this.sumainteres = 0;
            if (item.checked) {
              item.TEM = this.servifinMode
                ? Number(this.formTEM.controls['Tasa_Inversion'].value) / 100
                : this.TEM;
              item.pPAdelanto = this.formTEM.controls['Adelanto_Porcentaje'].value / 100;
              item.Moneda = this.formTEM.controls['TipoCambio'].value;
              item.Porcentaje_Interes_Adquirente = this.formTEM.controls['Interes_Adquirente'].value / 100;
              item.Tipo_Servicio = this.formTEM.controls['Tipo_Servicio'].value;
              item.Gastos_cesion = this.formTEM.controls['Gastos_cesion'].value;
              item.Gastos_legales = this.formTEM.controls['Gastos_Legales'].value;
              item.Interes_comision = this.formTEM.controls['Interes_Comision'].value;
              if (this.servifinMode) {
                item.Tasa_Inversion = this.formTEM.controls['Tasa_Inversion'].value;
                item.TasaCom = this.formTEM.controls['TasaCom'].value;
                item.PorcGrav = this.formTEM.controls['PorcGrav'].value;
                item.Comision_Minima = this.formTEM.controls['Comision_Minima'].value;
              }

              this.proformaService.factoring(item, 1).subscribe(
                responseFactoring => {
                  this.proformaDetalle[index].Adelanto_importe = responseFactoring['Adelanto'];
                  this.proformaDetalle[index].Remanente_importe = responseFactoring['Remanente'];
                  this.proformaDetalle[index].Interes_importe = responseFactoring['Interes'];
                  this.proformaDetalle[index].InteresProv = responseFactoring['InteresProv'];
                  this.proformaDetalle[index].InteresAdq = responseFactoring['InteresAdq'];
                  this.proformaDetalle[index].IGVProv = responseFactoring['IGVProv'];
                  this.proformaDetalle[index].IGVAdq = responseFactoring['IGVAdq'];
                  this.proformaDetalle[index].IGV = responseFactoring['IGVAdq'] + responseFactoring['IGVProv'];

                  this.proformaDetalle[index].Comision_importe = responseFactoring['Comision'];
                  this.proformaDetalle[index].Timbre = responseFactoring['Timbre'];
                  this.proformaDetalle[index].Feci = responseFactoring['Feci'];
                  this.proformaDetalle[index].Gastos_cesion = responseFactoring['G_cesion'];
                  this.proformaDetalle[index].Otros_Descuentos = (Number(responseFactoring['G_cesion'] / this.nroFacturas));
                  this.proformaDetalle[index].Gastos_legales = responseFactoring['G_legales'];
                  this.proformaDetalle[index].Desembolso_importe = responseFactoring['Desembolso'];
                  this.proformaDetalle[index].DesembolsoProvConfirming = responseFactoring['Desembolso'];
                  this.proformaDetalle[index].Factoring_importe = responseFactoring['IGVProv'] + responseFactoring['IGVAdq'] + responseFactoring['Timbre'] + responseFactoring['Feci'] + responseFactoring['InteresProv'] + responseFactoring['Comision'] + responseFactoring['G_legales'] + responseFactoring['G_cesion'];
                  if (this.servifinMode) {
                    this.proformaDetalle[index].VrNegociacion = responseFactoring['VrNegociacion'];
                    this.proformaDetalle[index].VrPresente = responseFactoring['VrPresente'];
                    this.proformaDetalle[index].VrGirar = responseFactoring['VrGirar'];
                    this.proformaDetalle[index].VrGravBancario = responseFactoring['VrGravBancario'];
                  }

                  this.ProformaTotales.VNPP += Number(this.proformaDetalle[index].VNPP);
                  this.ProformaTotales.Adelanto += Number(responseFactoring['Adelanto']);
                  this.ProformaTotales.Interes += Number(responseFactoring['Interes']);
                  this.ProformaTotales.IGVProv += Number(responseFactoring['IGVProv']);
                  this.ProformaTotales.InteresProv += Number(responseFactoring['InteresProv']);
                  this.ProformaTotales.Comision += Number(responseFactoring['Comision']);
                  this.ProformaTotales.Remanente += Number(responseFactoring['Remanente']);
                  this.ProformaTotales.Timbre += Number(responseFactoring['Timbre']);
                  this.ProformaTotales.Feci += Number(responseFactoring['Feci']);
                  this.ProformaTotales.Gastos_cesion += Number(this.proformaDetalle[index].Otros_Descuentos);
                  this.ProformaTotales.Gastos_legales += Number(responseFactoring['G_legales']);
                  this.ProformaTotales.Desembolso += Number(responseFactoring['Desembolso']); 
 
                  this.ProformaTotales.Valor_Venta_Retroventa += Number(responseFactoring['Adelanto']);
                  this.ProformaTotales.Valor_Venta_Retroventa_Saldo += Number(responseFactoring['Adelanto']);
 
                  cont_facturas++;
                  if (this.nroFacturas == cont_facturas) {

                    this.ProformaTotales.NroFacturas = this.nroFacturas;
                    this.ProformaTotales.Moneda = this.datosDN.TipoMoneda;
                    
                    let minimoComision =this.formTEM.controls['Comision_Minima'].value;
                    let comisionAcumulado = 0;

                    

                    if(this.ProformaTotales.Comision < minimoComision ){
                        this.ProformaTotales.Comision = 0;
                        this.ProformaTotales.IGVProv = 0;
                        this.ProformaTotales.Desembolso = 0;
                        this.proformaDetalle.forEach((item2,index2)=>{
                          let peso = 0;
                          let comision = 0;
                          if(this.proformaDetalle.length == index2+1){ 
                            comision =   minimoComision-comisionAcumulado;
                          }else{
                            peso = (this.proformaDetalle[index2].Interes_importe/this.ProformaTotales.Interes);
                            comision =  Math.round(minimoComision*peso);
                          }
                          
                          this.proformaDetalle[index2].Comision_importe = comision;
                          this.proformaDetalle[index2].IGV =  Math.round(comision*0.19);
                          this.proformaDetalle[index2].IGVProv = Math.round(comision*0.19);
                          this.proformaDetalle[index2].Desembolso_importe = (this.proformaDetalle[index2].Adelanto_importe-(this.proformaDetalle[index2].Interes_importe+this.proformaDetalle[index2].Comision_importe+this.proformaDetalle[index2].IGVProv));
                          comisionAcumulado += comision;

                          
                          this.ProformaTotales.Comision += Number(this.proformaDetalle[index2].Comision_importe); 
                          this.ProformaTotales.IGVProv += Number(this.proformaDetalle[index2].IGVProv); 
                          this.ProformaTotales.Desembolso += Number(this.proformaDetalle[index2].Desembolso_importe); 

                          console.log('proformaTotales',this.ProformaTotales);
                          
                          this.loading = false;
                        })
                        //this.calcularTotalesImporte();
                    } else{
                      this.loading = false;
                    }
                     
                  }
                }
              )
            } else {

              this.proformaDetalle[index].Adelanto_importe = 0;
              this.proformaDetalle[index].Remanente_importe = 0;
              this.proformaDetalle[index].Desembolso_importe = 0;
              this.proformaDetalle[index].Comision_importe = 0;
              this.proformaDetalle[index].Interes_importe = 0;
              this.proformaDetalle[index].InteresAdq = 0;
              this.proformaDetalle[index].InteresProv = 0;
              this.proformaDetalle[index].IGV_Importe = 0;
              this.proformaDetalle[index].IGV_porcentaje = 0;
              this.proformaDetalle[index].IGVProv = 0;
              this.proformaDetalle[index].DesembolsoProvConfirming = 0;

              this.ProformaTotales = {
                VNPP: 0,
                Adelanto: 0,
                Interes: 0,
                InteresAdq: 0,
                InteresProv: 0,
                Comision: 0,
                IGV_TOTAL: 0,
                Desembolso: 0,
                Remanente: 0,
                IGVProv: 0,
                Gastos_cesion: 0,
                DesembolsoProvConfirming: 0,
                Valor_Venta_Retroventa: 0,
                Valor_Venta_Retroventa_Saldo: 0,
                Otros_Descuentos :  0 
              };
            }
          })
        });
    } else {
      this.resetear();
      this.loading = false;
    }
    this.flgCalcular = true;
  }

  ObtenerRanking() {
    this.proformaService.obtenerRanking(this.datosDN.Num_Doc_Identificacion_Adq).subscribe(
      res => {
        this.formTEM.controls['Ranking'].setValue(res);
      }, err => {
        this.formTEM.controls['Ranking'].setValue(0);
        /*  let error = "";
            error = err.error.error;
          this.showNotification('warning', 'top', 'right', 'Error al intentar obtener ranking. \n Error: ' + error);*/
        //this.boton = false;
      }
    );
  }

  validarProvAdq(rucProv, rucAdq) {
    let proveedoresArr = [];
    let adquirentessArr = [];


    proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));

    for (let item of proveedoresArr) {
      if (item.Num_Doc_Identificacion == rucProv && item.Estado != "A") {

        Swal.fire({
          title: '¡Advertencia!',
          text: 'Cliente bloqueado.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(["/operaciones/proformas/documentos"]);
        this.ObtenerDocumentosNegociables();
        break;
      }
    }

    for (let item of adquirentessArr) {
      if (item.Num_Doc_Identificacion == rucAdq && item.Estado != "A") {

        Swal.fire({
          title: '¡Advertencia!',
          text: 'Pagador bloqueado.',
          type: 'error',
          allowOutsideClick: false,
          heightAuto: false
        });
        this.loginService.clickGuard = true;
        this.router.navigate(["/operaciones/proformas/documentos"]);
        this.ObtenerDocumentosNegociables();
        break;
      }
    }


  }

  tipoServicio(event) {

    this.formTEM.controls['Tipo_Servicio'].setValue(event);
    this.IGV_Porcentaje = this.igvPorcentajeGlobal;

    if (this.formTEM.controls.Tipo_Servicio.value == this.Id_Factoring || this.formTEM.controls.Tipo_Servicio.value == this.Id_Descuento) {
      this.formTEM.controls['Interes_Adquirente'].setValue('0');
      this.formTEM.controls['Importe_Adquirente'].setValue('0');
      this.IGV_Porcentaje = 0;
    }

    this.resetear();
  }

  ObtenerDocumentosNegociables() {

    this.loading = true;

    let Datos: any = {
      Tipo_Comprobante: '',
      Moneda: 0,
      Num_Doc_IdentificacionProv: '',
      Num_Doc_IdentificacionADQ: '',
      Tipo_Operacion: 'PR'
    };

    Datos.Tipo_Comprobante = this.datosDN.Tipo_Comprobante;
    Datos.Moneda = this.datosDN.TipoMoneda;
    Datos.Num_Doc_IdentificacionProv = this.datosDN.Num_Doc_Identificacion_Prov;
    Datos.Num_Doc_IdentificacionADQ = this.datosDN.Num_Doc_Identificacion_Adq;

    this.proformaService.ObtenerDocumentosNegociables(Datos).subscribe(
      res => {
        this.arrayDocumentos = res;
        this.resetear();
        this.loading = false;
      });
  }

  diferenciaEntreDiasEnDias(a, b) {
    var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    return Math.floor((utc1 - utc2) / this.MILISENGUNDOS_POR_DIA);
  }

  resetear() {
    this.flgCalcular = false;
    this.proformaDetalle = [];
    this.arrayDocumentos.forEach((item, index) => {
      this.proformaDetalle.push(item as ProformaDetalle);

      let fecha = moment(item.Fecha_de_Pago);

      this.proformaDetalle[index].Plazo = this.diferenciaEntreDiasEnDias(fecha['_d'], this.formTEM.controls['Fecha_Desembolso'].value._d);
      this.proformaDetalle[index].Adelanto_importe = 0;
      this.proformaDetalle[index].Interes_importe = 0;
      this.proformaDetalle[index].Comision_importe = 0;
      this.proformaDetalle[index].InteresAdq = 0;
      this.proformaDetalle[index].InteresProv = 0;
      this.proformaDetalle[index].IGV_Importe = 0;
      this.proformaDetalle[index].Desembolso_importe = 0;
      this.proformaDetalle[index].Remanente_importe = 0;
      this.proformaDetalle[index].IGVProv = 0;
      this.proformaDetalle[index].DesembolsoProvConfirming = 0;
      this.proformaDetalle[index].ComisionTotal = 0;
      this.proformaDetalle[index].IGV_porcentaje = 0;
      this.proformaDetalle[index].IGVAdq = 0;
      this.proformaDetalle[index].Timbre = 0;
      this.proformaDetalle[index].Feci = 0;
      this.proformaDetalle[index].Gastos_cesion = 0;
      this.proformaDetalle[index].Otros_Descuentos = 0;
      this.proformaDetalle[index].Gastos_legales = 0;
    });

    this.ProformaTotales = {
      VNPP: 0,
      Adelanto: 0,
      Interes: 0,
      InteresAdq: 0,
      InteresProv: 0,
      Comision: 0,
      IGV_TOTAL: 0,
      Desembolso: 0,
      Remanente: 0,
      IGVProv: 0,
      DesembolsoProvConfirming: 0,
      Timbre: 0,
      Feci: 0,
      Gastos_legales: 0,
      Gastos_cesion: 0,
      Plazo:0, 
      Valor_Venta_Retroventa :  0,
      Valor_Venta_Retroventa_Saldo :  0,
      Otros_Descuentos :  0
    };

  }
  MetCerrarsimuladorDetalle(){ 
    this.varAbrirInversionista = false;
  }
  DeleteInversionista(id: any,valor : any){
      this.inversionistaDetalle.splice(id, 1);
      this.ProformaTotales.Valor_Venta_Retroventa_Saldo = this.ProformaTotales.Valor_Venta_Retroventa_Saldo+valor;
  }
  AbriInversionista(){
    console.log("-->",this.ProformaTotales);
    this.varAbrirInversionista = true;
  }

  RecibirInversionistaDetalle(event){
    this.inversionistaDetalle.push(event); 
    this.varAbrirInversionista = false;
    let total_inversion = 0;
    let total_interes = 0;
    this.inversionistaDetalle.forEach(element => {
      total_inversion += element.Valor_Inversion;
      total_interes += element.rendimiento;
    });
    this.ProformaTotales.Valor_Venta_Retroventa_Saldo = this.ProformaTotales.Valor_Venta_Retroventa-total_inversion;
    //this.obtenerTEM();
     
  }

  calcularInversionesDefecto(){
    let dataCalc = new InversionistaDetalle;
    dataCalc.Valor_Inversion = this.ProformaTotales.Valor_Venta_Retroventa_Saldo;
    dataCalc.Proporcion_Retroventa = this.ProformaTotales.Valor_Venta_Retroventa_Saldo;
    dataCalc.Tipo_Servicio = this.proformaGeneral.Tipo_Servicio;
    dataCalc.Plazo =  this.ProformaTotales.Plazo;
    dataCalc.porcentaje_rendimiento = this.proformaGeneral.Tasa_Mensual;
    dataCalc.porcentaje_retroventa = 1;
    dataCalc.rendimiento = this.ProformaTotales.Interes;
    dataCalc.porcentaje_rendimiento_neto = this.proformaGeneral.Tasa_Mensual;
    dataCalc.rendimiento_neto = this.ProformaTotales.Interes;
    dataCalc.Interes = this.ProformaTotales.Interes;
    dataCalc.Moneda = this.proformaGeneral.Moneda;
    dataCalc.fecha_inversion = this.proformaGeneral.Fecha_Desembolso;
    dataCalc.valor_neto = this.ProformaTotales.Valor_Venta_Retroventa_Saldo+this.ProformaTotales.Interes;
    dataCalc.valor_recibir = dataCalc.valor_neto
    dataCalc.valor_vencimiento = dataCalc.valor_neto
    dataCalc.idFondo = "174";
    dataCalc.estado = "O";
    this.inversionistaDetalle.push(dataCalc);
  }

  guardarProforma() {
    if (this.formTEM.controls['Tipo_Servicio'].value == '') {
      Swal.fire({
        title: "¡Advertencia!",
        text: "Seleccione el tipo de servicio.",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }
    this.proformaGeneral.ProformaDetalle = [];
    this.proformaGeneral.Num_Doc_Identificacion_Prov = this.datosDN.Num_Doc_Identificacion_Prov;
    this.proformaGeneral.Num_Doc_Identificacion_ADQ = this.datosDN.Num_Doc_Identificacion_Adq;
    this.proformaGeneral.Ranking_Adquirente = this.formTEM.controls['Ranking'].value;
    this.proformaGeneral.Tasa_Tipo_de_Calculo = 'M';
    this.proformaGeneral.Tasa_Mensual_Sistema = this.TEMAutomatico;
    this.proformaGeneral.Tasa_Mensual = this.TEM;
    this.proformaGeneral.Tasa_Anual = this.TEM;
    this.proformaGeneral.Tasa_Diaria = this.TEM;
    this.proformaGeneral.Moneda = this.datosDN.TipoMoneda;
    this.proformaGeneral.Adelanto_porcentaje = this.formTEM.controls['Adelanto_Porcentaje'].value / 100;
    this.proformaGeneral.Fecha_Desembolso = this.datepipe.transform(this.formTEM.controls['Fecha_Desembolso'].value, 'yyyy-MM-dd');
    this.proformaGeneral.Tipo_Servicio = this.formTEM.controls['Tipo_Servicio'].value;
    this.proformaGeneral.Porcentaje_Interes_Adquirente = this.formTEM.controls['Interes_Adquirente'].value / 100;
    this.proformaGeneral.Observaciones = this.formTEM.controls['Observaciones'].value;
    this.proformaGeneral.Alta_Usuario = this.user.Usuario;

    

    if(this.inversionistaDetalle.length > 0){
      this.proformaGeneral.InversionistaDetalle = this.inversionistaDetalle;
    }else{
      this.calcularInversionesDefecto();
      this.proformaGeneral.InversionistaDetalle = this.inversionistaDetalle;
    }

    let now = moment();
    let FVig = now.add(this.PlazoMaximo, 'days');

    this.proformaGeneral.Fecha_Vigencia = this.datepipe.transform(FVig, 'yyyy-MM-dd');
    this.proformaGeneral.Cantidad_de_Documentos_Negociables = 0;

    this.actualizarDocumentos = [];
    for (let item of this.proformaDetalle) {
      if (item.checked) {

        if (item.Plazo < this.varDiasMin) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Fuera_Rango}`,
            text: `${this.msgAgregarSimulador.Error_Plazo_Dias}`,
            heightAuto: false
          });
          return;
        }

        if (item.DesembolsoProvConfirming <= 0) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Valor_Negativo}`,
            text: `${this.msgAgregarSimulador.Error_Desemboldo}`,
            heightAuto: false
          });
          return;
        }

        this.actualizarDocumentos.push({ "idComprobante": String(item.idComprobante), "Estado": "T" });
        this.proformaGeneral.Cantidad_de_Documentos_Negociables += 1;
        this.proformaGeneral.ProformaDetalle.push(item);

      }
    }

    if (this.proformaGeneral.ProformaDetalle.length <= 0) {
      Swal.fire({
        title: "¡Advertencia!",
        text: "Select a document.",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
      return;
    }

    Swal.fire({
      title: 'Espere',
      text: 'Guardando la información.',
      type: 'info',
      allowOutsideClick: false,
      heightAuto: false
    });
    Swal.showLoading();

    this.proformaService.CrearProforma(this.proformaGeneral).subscribe(
      responseProforma => {
        this.ProformaSave = responseProforma;
        this.idProforma = this.ProformaSave.idProforma;
        this.idProveedor = this.ProformaSave.idProveedor;

        this.empresasService.obtenerContactosEmpresa(this.idProveedor.toString()).subscribe(
          res => {
            this.rProveedor = res;
            // Buscando tipos de Contactos --Representante Legal
            let tipoContacto: any = [];
            let guiaTipo: any;
            this.guiasService.TipoContacto.subscribe(
              response => {
                tipoContacto = response;
                guiaTipo = tipoContacto.find(state => state.Codigo.toLowerCase().indexOf('rl') === 0)
              }
            );

            this.rProveedor = this.rProveedor.filter(
              state => state.Des_Estado.toLowerCase().indexOf('activo') === 0 && state.Tipo_de_Contacto === guiaTipo.idGuia
            );

            if (this.rProveedor.length > 0) {
              /*this.correo = this.rProveedor[0].Correo.trim();
              this.Nombre_de_Contacto = this.rProveedor[0].Nombre_de_Contacto.trim();*/
              this.correo = "demo";
              this.Nombre_de_Contacto = "demo";
              Swal.fire({
                title: '¡Registro exitoso!',
                html: '¿Desea enviar el PDF al correo de <b>COMUNICACIONES</b>?',
                type: "success",
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí',
                cancelButtonText: 'No',
                heightAuto: false
              }).then((result) => {
                if (result.value) {
                  let $body: any;
                  $body = { 'idProforma': this.idProforma.toString(), 'nombre': this.Nombre_de_Contacto, 'correo': this.correo };

                  this.proformaService.enviarProformaProv($body).subscribe(
                    res2 => {
                      this.showNotification('success', 'top', 'right', 'Correo enviado correctamente.');
                    }, err => {
                      let error = "";
                      error = err.error.error;
                      this.showNotification('warning', 'top', 'right', 'Error: ' + error);
                    }
                  );
                }
                window.open(this.ProformaSave.Adjunto_PDF, "_blank");
                this.loginService.clickGuard = true;
                this.router.navigate(["/operaciones/proformas/listado"]);
              });
            } else {
              Swal.fire({
                title: '¡Registro exitoso!',
                type: 'success',
                allowOutsideClick: true
              });
              window.open(this.ProformaSave.Adjunto_PDF, "_blank");
              this.loginService.clickGuard = true;
              this.router.navigate(["/operaciones/proformas/listado"]);
            }
          }, (err: HttpErrorResponse) => {
            Swal.fire({
              title: '¡Registro exitoso!',
              type: 'success',
              footer: 'Contact no encontrado.',
              allowOutsideClick: true,
              heightAuto: false
            });
            window.open(this.ProformaSave.Adjunto_PDF, "_blank");
            this.loginService.clickGuard = true;
            this.router.navigate(["/operaciones/proformas/listado"]);
          }
        );
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error.code == 500) {
          err.error.error = "Contact support."
        }
        Swal.fire({
          title: "Error",
          text: err.error.error,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
    );
  }

  validar() {
    if (this.formTEM.controls.Tipo_Servicio.value == this.Id_Factoring || this.formTEM.controls.Tipo_Servicio.value == this.Id_Descuento) {
      this.proformaGeneral.Porcentaje_Interes_Adquirente = 0
    }


    for (let item of this.proformaDetalle) {
      if (item.checked) {

        if (item.Plazo < this.varDiasMin) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Fuera_Rango}`,
            text: `${this.msgAgregarSimulador.Error_Plazo_Dias}`,
            heightAuto: false
          });
          return;
        }

        if (item.Desembolso_importe <= 0) {
          Swal.fire({
            title: `${this.msgTitulos.Error_Valor_Negativo}`,
            text: `${this.msgAgregarSimulador.Error_Desemboldo}`,
            heightAuto: false
          });
          return;
        }


        item.Factoring_importe = item.Interes_importe + item.Comision_importe;
        item.Factoring_SUNAT_importe = item.Interes_importe + item.Comision_importe + item.IGV_Importe;
        this.proformaGeneral.Cantidad_de_Documentos_Negociables += 1;
        this.proformaGeneral.ProformaDetalle.push(item);

      }
    }

    if (this.proformaGeneral.ProformaDetalle.length <= 0) {
      Swal.fire({
        title: "¡Advertencia!",
        text: "Select a document.",
        type: "warning",
        allowOutsideClick: false,
        heightAuto: false
      });
    }
  }

  actualizarDocumentosN(docs: any[]) {
    for (let item of docs) {
      this.documentoNegociableService.CambiarEstadoComprobante(item, item.idComprobante).subscribe(
        res => {
          console.log('Documento Negociable actualizado')
        });
    }
  }

  editarTEM() {
    Swal.fire({
      title: "Enter rate",
      html: `
        <input id="swal-input1" class="swal2-input">
        <span class="after_tasa">%</span>
      `,
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Change',
      reverseButtons: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      heightAuto: false,
      preConfirm: () => {
        const data = document.getElementById('swal-input1') as HTMLInputElement;
        return [
          data.value
        ];
      }
    }).then((result) => {
      if (result.dismiss) {
        return;
      }
      if (result.value[0] < (this.varTasaMin - 0.1 * 100) || result.value[0] > (this.varTasaMax + 0.1 * 100)) {
        Swal.fire({
          title: `${this.msgTitulos.Error_Fuera_Rango}`,
          text: `${this.msgAgregarSimulador.Error_TEM}`,
          heightAuto: false
        })
        return;
      }
      this.calcularProforma(false, result.value[0] / 100);
      // console.log("dadada",result.value[0]);
    });

  }

  showNotification(type, from, align, message) {

    //const type = ['','info','success','warning','danger']; => tipo de notificacion
    //from = [Top,bottom,etc] => orientacion vertical
    //align = center, left, right => orientacion horizontal

    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }
}

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return (control && control.invalid);
  }
}